import axios from '../AxiosInstance';
import { getApiUrl } from '../../utils/ApiUtils';

const projectBase = (companyId) => `${companyId}/projects`;
const rateCardBase = (companyId) => `${companyId}/rate-cards`;

// ─── PROJECTS ───

export const getProjects = (companyId) =>
  axios.get(getApiUrl(projectBase(companyId)), { withCredentials: true });

export const getMyProjects = (companyId) =>
  axios.get(getApiUrl(`${projectBase(companyId)}/mine`), { withCredentials: true });

export const getProject = (companyId, projectId) =>
  axios.get(getApiUrl(`${projectBase(companyId)}/${projectId}`), { withCredentials: true });

export const createProject = (companyId, data) =>
  axios.post(getApiUrl(projectBase(companyId)), data, { withCredentials: true });

export const updateProject = (companyId, projectId, data) =>
  axios.put(getApiUrl(`${projectBase(companyId)}/${projectId}`), data, { withCredentials: true });

export const getProjectTasks = (companyId, projectId) =>
  axios.get(getApiUrl(`${projectBase(companyId)}/${projectId}/tasks`), { withCredentials: true });

export const getProjectMembers = (companyId, projectId) =>
  axios.get(getApiUrl(`${projectBase(companyId)}/${projectId}/members`), { withCredentials: true });

export const addProjectMember = (companyId, projectId, data) =>
  axios.post(getApiUrl(`${projectBase(companyId)}/${projectId}/members`), data, { withCredentials: true });

export const removeProjectMember = (companyId, memberId) =>
  axios.delete(getApiUrl(`${companyId}/members/${memberId}`), { withCredentials: true });

export const getProjectStats = (companyId, projectId) =>
  axios.get(getApiUrl(`${projectBase(companyId)}/${projectId}/stats`), { withCredentials: true });

// ─── PROJECT REPORTS ───

export const getProjectProfitabilityReport = (companyId, params) =>
  axios.get(getApiUrl(`${projectBase(companyId)}/reports/profitability`), { params, withCredentials: true });

export const getProjectBudgetBurnReport = (companyId, params) =>
  axios.get(getApiUrl(`${projectBase(companyId)}/reports/budget-burn`), { params, withCredentials: true });

export const getProjectWipAgingReport = (companyId) =>
  axios.get(getApiUrl(`${projectBase(companyId)}/reports/wip-aging`), { withCredentials: true });

export const getProjectWipReport = (companyId) =>
  axios.get(getApiUrl(`${projectBase(companyId)}/reports/wip`), { withCredentials: true });

export const exportProjectReportCsv = (companyId, params) =>
  axios.get(getApiUrl(`${projectBase(companyId)}/reports/export`), { params, withCredentials: true, responseType: 'blob' });

// ─── RATE CARDS ───

export const getRateCards = (companyId) =>
  axios.get(getApiUrl(rateCardBase(companyId)), { withCredentials: true });

export const getRateCard = (companyId, rateCardId) =>
  axios.get(getApiUrl(`${rateCardBase(companyId)}/${rateCardId}`), { withCredentials: true });

export const createRateCard = (companyId, data) =>
  axios.post(getApiUrl(rateCardBase(companyId)), data, { withCredentials: true });

export const resolveRate = (companyId, params) =>
  axios.get(getApiUrl(`${rateCardBase(companyId)}/resolve`), { params, withCredentials: true });
